import React from 'react'
import './coverLoader.css'

//PASS IN AN OPTION THAT LETS YOU TELL IT IF IT'S ABSOLUTE OR RELATIVE AND BIG

const Loader = (props) => (
  <div className={`cover-parent-loader ${props.className || ''}`}>
    <div style={{ textAlign: 'center' }}>
      {/* Commented out older, bigger loader */}
      {/* <div className="circle-loader"></div> */}
      <div className="has-text-centered">
        <i className="fas fa-3x fa-cog fa-spin"></i>
      </div>
      <span className="loader-text is-block mt-3 has-text-weight-bold">
        {props.text}
      </span>
    </div>
  </div>
)
export default Loader
